export default {
  title: 'Как вам заказ?',
  ratingLabel: 'Оцените экскурсию',
  starAriaLabel: 'Оценка {star} из 5',
} as const;
